"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
var _typeof = require("@babel/runtime/helpers/typeof");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _slicedToArray2 = _interopRequireDefault(require("@babel/runtime/helpers/slicedToArray"));
var _react = _interopRequireWildcard(require("react"));
var _material = require("@mui/material");
var _apis = require("../../../../@apis");
var _hooks = require("../../../../@hooks");
var _SimpleButton = _interopRequireDefault(require("../../../../@custom/SimpleButton"));
var _Icon = _interopRequireDefault(require("../../../../@custom/Icon"));
var _TextInput = _interopRequireDefault(require("../../../../@custom/TextInput"));
var _propTypes = _interopRequireDefault(require("prop-types"));
function _getRequireWildcardCache(nodeInterop) { if (typeof WeakMap !== "function") return null; var cacheBabelInterop = new WeakMap(); var cacheNodeInterop = new WeakMap(); return (_getRequireWildcardCache = function _getRequireWildcardCache(nodeInterop) { return nodeInterop ? cacheNodeInterop : cacheBabelInterop; })(nodeInterop); }
function _interopRequireWildcard(obj, nodeInterop) { if (!nodeInterop && obj && obj.__esModule) { return obj; } if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") { return { "default": obj }; } var cache = _getRequireWildcardCache(nodeInterop); if (cache && cache.has(obj)) { return cache.get(obj); } var newObj = {}; var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor; for (var key in obj) { if (key !== "default" && Object.prototype.hasOwnProperty.call(obj, key)) { var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null; if (desc && (desc.get || desc.set)) { Object.defineProperty(newObj, key, desc); } else { newObj[key] = obj[key]; } } } newObj["default"] = obj; if (cache) { cache.set(obj, newObj); } return newObj; }
function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); enumerableOnly && (symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; })), keys.push.apply(keys, symbols); } return keys; }
function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = null != arguments[i] ? arguments[i] : {}; i % 2 ? ownKeys(Object(source), !0).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)) : ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } return target; }
/**
 * @typedef CNPJData
 * @type {import("./index.jsx").CNPJData}
 */

/**
 * @typedef StepProps
 * @type {import("./index.jsx").StepProps}
 */

/**
 * @param {StepProps} props
 */
function ConfirmAddress(props) {
  var _errorMsgs$cep, _errorMsgs$cep2;
  var user = props.user,
    updateUser = props.updateUser,
    goBack = props.goBack,
    goNext = props.goNext;
  var _useErrors = (0, _hooks.useErrors)(),
    errorMsgs = _useErrors.errorMsgs,
    addErrorMsg = _useErrors.addErrorMsg,
    removeErrorMsg = _useErrors.removeErrorMsg;
  var _useState = (0, _react.useState)(false),
    _useState2 = (0, _slicedToArray2["default"])(_useState, 2),
    acceptedTerms = _useState2[0],
    setAcceptedTerms = _useState2[1];
  var CEP_SIZE = 8;
  var validateUpdate = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee(prop, value) {
      var cep;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) switch (_context.prev = _context.next) {
          case 0:
            if (!(prop === 'cep')) {
              _context.next = 8;
              break;
            }
            cep = value.replace(/\D/g, '');
            if (!(cep.length < CEP_SIZE)) {
              _context.next = 7;
              break;
            }
            addErrorMsg('cep', 'invalid-cep');
            return _context.abrupt("return", false);
          case 7:
            removeErrorMsg('cep', 'invalid-cep');
          case 8:
            if (!(prop === 'logradouro')) {
              _context.next = 15;
              break;
            }
            if (value) {
              _context.next = 14;
              break;
            }
            addErrorMsg('logradouro', 'logradouro-missing');
            return _context.abrupt("return", false);
          case 14:
            removeErrorMsg('logradouro', 'logradouro-missing');
          case 15:
            if (!(prop === 'numero')) {
              _context.next = 22;
              break;
            }
            if (value) {
              _context.next = 21;
              break;
            }
            addErrorMsg('numero', 'numero-missing');
            return _context.abrupt("return", false);
          case 21:
            removeErrorMsg('numero', 'numero-missing');
          case 22:
            if (!(prop === 'bairro')) {
              _context.next = 29;
              break;
            }
            if (value) {
              _context.next = 28;
              break;
            }
            addErrorMsg('bairro', 'bairro-missing');
            return _context.abrupt("return", false);
          case 28:
            removeErrorMsg('bairro', 'bairro-missing');
          case 29:
            if (!(prop === 'cidade')) {
              _context.next = 36;
              break;
            }
            if (value) {
              _context.next = 35;
              break;
            }
            addErrorMsg('cidade', 'cidade-missing');
            return _context.abrupt("return", false);
          case 35:
            removeErrorMsg('cidade', 'cidade-missing');
          case 36:
            if (!(prop === 'estado')) {
              _context.next = 43;
              break;
            }
            if (value) {
              _context.next = 42;
              break;
            }
            addErrorMsg('estado', 'estado-missing');
            return _context.abrupt("return", false);
          case 42:
            removeErrorMsg('estado', 'estado-missing');
          case 43:
            return _context.abrupt("return", true);
          case 44:
          case "end":
            return _context.stop();
        }
      }, _callee);
    }));
    return function validateUpdate(_x, _x2) {
      return _ref.apply(this, arguments);
    };
  }();
  var validateUser = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee2() {
      var isValid, _i, _Object$entries, _Object$entries$_i, prop, value;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) switch (_context2.prev = _context2.next) {
          case 0:
            isValid = true;
            _i = 0, _Object$entries = Object.entries(user);
          case 2:
            if (!(_i < _Object$entries.length)) {
              _context2.next = 12;
              break;
            }
            _Object$entries$_i = (0, _slicedToArray2["default"])(_Object$entries[_i], 2), prop = _Object$entries$_i[0], value = _Object$entries$_i[1];
            _context2.next = 6;
            return validateUpdate(prop, value);
          case 6:
            if (_context2.sent) {
              _context2.next = 9;
              break;
            }
            isValid = false;
            return _context2.abrupt("break", 12);
          case 9:
            _i++;
            _context2.next = 2;
            break;
          case 12:
            return _context2.abrupt("return", isValid);
          case 13:
          case "end":
            return _context2.stop();
        }
      }, _callee2);
    }));
    return function validateUser() {
      return _ref2.apply(this, arguments);
    };
  }();

  /**
   * @param {React.ChangeEvent<HTMLInputElement>} evt
   * @returns {Promise<void>}
   **/
  var handleUpdateCep = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee3(evt) {
      var value, cep, cepInfo;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) switch (_context3.prev = _context3.next) {
          case 0:
            value = evt.target.value;
            cep = value.replace(/\D/g, '');
            if (!(cep.length === CEP_SIZE)) {
              _context3.next = 7;
              break;
            }
            _context3.next = 5;
            return _apis.cepApi.consult(cep);
          case 5:
            cepInfo = _context3.sent;
            updateUser({
              local: cepInfo
            });
          case 7:
            updateUser({
              cep: value
            });
            validateUpdate('cep', value);
          case 9:
          case "end":
            return _context3.stop();
        }
      }, _callee3);
    }));
    return function handleUpdateCep(_x3) {
      return _ref3.apply(this, arguments);
    };
  }();

  /**
   * @param {string} prop
   * @returns {(evt: React.ChangeEvent<HTMLInputElement>) => Promise<void>}
   **/
  var handleUpdateUserLocal = function handleUpdateUserLocal(prop) {
    return /*#__PURE__*/function () {
      var _ref4 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee4(evt) {
        var value, prevLocal;
        return _regenerator["default"].wrap(function _callee4$(_context4) {
          while (1) switch (_context4.prev = _context4.next) {
            case 0:
              value = evt.target.value;
              prevLocal = user.local;
              updateUser({
                local: _objectSpread(_objectSpread({}, prevLocal), {}, (0, _defineProperty2["default"])({}, prop, value))
              });
              validateUpdate(prop, value);
            case 4:
            case "end":
              return _context4.stop();
          }
        }, _callee4);
      }));
      return function (_x4) {
        return _ref4.apply(this, arguments);
      };
    }();
  };
  var handleCreateAccount = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee5() {
      var isValid;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) switch (_context5.prev = _context5.next) {
          case 0:
            _context5.next = 2;
            return validateUser();
          case 2:
            isValid = _context5.sent;
            if (isValid) {
              _context5.next = 5;
              break;
            }
            return _context5.abrupt("return");
          case 5:
            goNext(_objectSpread({}, user));
          case 6:
          case "end":
            return _context5.stop();
        }
      }, _callee5);
    }));
    return function handleCreateAccount() {
      return _ref5.apply(this, arguments);
    };
  }();
  var handleValidForm = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee6() {
      var isValid;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) switch (_context6.prev = _context6.next) {
          case 0:
            _context6.next = 2;
            return validateUser();
          case 2:
            isValid = _context6.sent;
            if (isValid) {
              _context6.next = 5;
              break;
            }
            return _context6.abrupt("return");
          case 5:
          case "end":
            return _context6.stop();
        }
      }, _callee6);
    }));
    return function handleValidForm() {
      return _ref6.apply(this, arguments);
    };
  }();
  return /*#__PURE__*/_react["default"].createElement(_react["default"].Fragment, null, /*#__PURE__*/_react["default"].createElement("span", {
    className: "Auth-right-form-link",
    onClick: goBack
  }, "\xAB Voltar"), /*#__PURE__*/_react["default"].createElement("br", null), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    alwaysShowMask: true,
    label: "CEP",
    placeholder: "12345-67",
    mask: "99999-999",
    onChange: handleUpdateCep,
    value: user.cep
  }), ((_errorMsgs$cep = errorMsgs.cep) === null || _errorMsgs$cep === void 0 ? void 0 : _errorMsgs$cep.length) > 0 && errorMsgs.cep.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, "* ", errors[msg]);
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Logradouro",
    onChange: handleUpdateUserLocal('logradouro'),
    value: user.local.logradouro
  }), ((_errorMsgs$cep2 = errorMsgs.cep) === null || _errorMsgs$cep2 === void 0 ? void 0 : _errorMsgs$cep2.length) > 0 && errorMsgs.cep.map(function (msg) {
    return /*#__PURE__*/_react["default"].createElement("p", {
      key: msg,
      className: "Auth-right-form-error"
    }, "* ", errors[msg]);
  }), /*#__PURE__*/_react["default"].createElement(_material.FormGroup, {
    row: true,
    className: "Auth-right-form-textBox",
    id: "formGroup-Number"
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "N\xFAmero",
    onChange: handleUpdateUserLocal('numero'),
    value: user.local.numero
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Bairro",
    onChange: handleUpdateUserLocal('bairro'),
    value: user.local.bairro
  })), /*#__PURE__*/_react["default"].createElement(_material.FormGroup, {
    row: true
  }, /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Cidade",
    onChange: handleUpdateUserLocal('cidade'),
    value: user.local.cidade
  }), /*#__PURE__*/_react["default"].createElement(_TextInput["default"], {
    label: "Estado",
    onChange: handleUpdateUserLocal('estado'),
    value: user.local.estado
  })), /*#__PURE__*/_react["default"].createElement(_material.FormControlLabel, {
    label: /*#__PURE__*/_react["default"].createElement("div", {
      className: "Auth-right-checkbox",
      onClick: handleValidForm
    }, /*#__PURE__*/_react["default"].createElement("div", null, /*#__PURE__*/_react["default"].createElement("a", {
      href: "/terms-and-conditions",
      target: "_blank",
      rel: "noreferrer"
    }, "Termos e Condi\xE7\xF5es"), ' ', "&", ' ', /*#__PURE__*/_react["default"].createElement("a", {
      href: "/privacy-policy",
      target: "_blank",
      rel: "noreferrer"
    }, "Pol\xEDtica de Privacidade"))),
    control: /*#__PURE__*/_react["default"].createElement(_material.Checkbox, {
      onChange: function onChange(evt, checked) {
        return setAcceptedTerms(checked);
      },
      checked: acceptedTerms
    })
  }), /*#__PURE__*/_react["default"].createElement(_SimpleButton["default"], {
    fullWidth: true,
    onClick: handleCreateAccount,
    disabled: !acceptedTerms
  }, /*#__PURE__*/_react["default"].createElement("span", null, "Criar conta"), /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    icon: "faUserPlus"
  })));
}
ConfirmAddress.propTypes = {
  user: _propTypes["default"].shape({
    cep: _propTypes["default"].string.isRequired,
    phone: _propTypes["default"].string.isRequired,
    email: _propTypes["default"].string.isRequired,
    firstName: _propTypes["default"].string.isRequired,
    lastName: _propTypes["default"].string.isRequired,
    local: _propTypes["default"].shape({
      cep: _propTypes["default"].string.isRequired,
      logradouro: _propTypes["default"].string.isRequired,
      numero: _propTypes["default"].string.isRequired,
      bairro: _propTypes["default"].string.isRequired,
      cidade: _propTypes["default"].string.isRequired,
      estado: _propTypes["default"].string.isRequired
    }).isRequired
  }).isRequired,
  updateUser: _propTypes["default"].func.isRequired,
  goBack: _propTypes["default"].func.isRequired,
  goNext: _propTypes["default"].func.isRequired
};
var _default = ConfirmAddress;
exports["default"] = _default;
var errors = {
  'first-name-missing': 'Primeiro nome é obrigatório',
  'last-name-missing': 'Último nome é obrigatório',
  'invalid-email': 'Email inválido',
  'email-already-taken': 'Email já está em uso',
  'invalid-phone': 'Telefone inválido',
  'invalid-cep': 'CEP inválido'
};